import React from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import project from './ProjectHighlight.module.css'
import { useProjectReport } from '../../../Hooks/Features/ProjectHighlight/useProjectReport.js';
import { useCommon } from '../../../Hooks/Common/useCommon.js';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function ProjectReport() {

    const { checkPermission } = useCommon();
    const { tagRef, columnDefs, rowData } = useProjectReport();
    const navigate = useNavigate();

    return (
        <div>
            <div>
                <div className='d-flex justify-content-end'>
                    <button className='button btn-default' onClick={() => navigate("/project-highlight")}><FontAwesomeIcon icon="fa-solid fa-arrow-left" /> Back</button>
                </div>
                <div ref={() => checkPermission("Project Issue", tagRef)}>
                    <div ref={tagRef} id='{"tabname": "projectIssue", "data": "project_highlight_li"}' className={`ag-theme-alpine ${project['projectissuetype-grid']}`}>
                        <AgGridReact columnDefs={columnDefs} rowData={rowData} rowHeight={30}
                            headerHeight={30} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProjectReport;